import { createAction, props } from '@ngrx/store';
import { IFuncionario } from 'src/app/shared/interfaces/funcionario/ifuncionario';

enum FuncionarioActionType {
    LOAD_FUNCIONARIO = '[funcionario] load funcionario from api',
    LOAD_FUNCIONARIO_SUCCESS = '[funcionario] load funcionario from api return success',
    LOAD_FUNCIONARIO_ERROR = '[funcionario] load funcionario from api return error',

    SAVE_FUNCIONARIO = '[funcionario] save funcionario from api',
    SAVE_FUNCIONARIO_SUCCESS = '[funcionario] save funcionario from api return success',
    SAVE_FUNCIONARIO_ERROR = '[funcionario] save funcionario from api return error',

    EDIT_FUNCIONARIO = '[funcionario] edit funcionario',
    EDIT_FUNCIONARIO_SUCCESS = '[funcionario] edit funcionario success',
    EDIT_FUNCIONARIO_ERROR = '[funcionario] edit funcionario error',

    DELETE_FUNCIONARIO = "[funcionario] delete funcionario from api"

}

const loadFuncionario = createAction(
  FuncionarioActionType.LOAD_FUNCIONARIO,  (totalPages?: string) => ({ totalPages })
);

const loadFuncionarioSuccess = createAction(
    FuncionarioActionType.LOAD_FUNCIONARIO_SUCCESS, props<{ lista: IFuncionario[]  }>()
);

const loadFuncionarioError = createAction(
    FuncionarioActionType.LOAD_FUNCIONARIO_ERROR
);

const saveFuncionario = createAction(
    FuncionarioActionType.SAVE_FUNCIONARIO, props<{ funcionario: IFuncionario }>()
)

const saveFuncionarioSuccess = createAction(
    FuncionarioActionType.SAVE_FUNCIONARIO_SUCCESS
)

const saveFuncionarioError = createAction(
    FuncionarioActionType.SAVE_FUNCIONARIO_ERROR
)

const editFuncionario = createAction(
    FuncionarioActionType.EDIT_FUNCIONARIO,
    props<{ funcionario: IFuncionario, id: number}>()

)

const editFuncionarioSuccess = createAction(
    FuncionarioActionType.EDIT_FUNCIONARIO_SUCCESS
)

const editFuncionarioError = createAction(
    FuncionarioActionType.EDIT_FUNCIONARIO_ERROR
)



const deleteFuncionario = createAction(
    FuncionarioActionType.DELETE_FUNCIONARIO,
    props<{ id: number }>()
)

export const funcionarioActions = {
    loadFuncionario,
    loadFuncionarioSuccess,
    loadFuncionarioError,
    saveFuncionario,
    saveFuncionarioSuccess,
    saveFuncionarioError,
    deleteFuncionario,
    editFuncionario,
    editFuncionarioSuccess,
    editFuncionarioError,
}
